<template>
  <div class="row">
    <div class="col-md-12">
      <div class="table-responsive">
        <table class="table table-hover table-bordered">
          <thead>
            <tr>
              <th />
              <th>{{ $t('label.current') }}</th>
              <th>{{ $t('label.previous') }}</th>
              <th>{{ $t('label.percentage') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ titlePrimary }}</td>
              <td>
                <p class="text-number">
                  {{ currentTotal }}
                </p>
              </td>
              <td>
                <p class="text-number">
                  {{ previousTotal }}
                </p>
              </td>
              <td>
                <template v-if="currentTotal > previousTotal">
                  <span class="description-percentage text-green">
                    <i class="fa fa-caret-up" />
                    <template v-if="previousTotal > 0">
                      {{ ((currentTotal-previousTotal)/previousTotal) | percentage }}
                    </template>
                    <template v-else>
                      {{ (currentTotal) | percentage }}
                    </template>
                  </span>
                </template>
                <template v-else-if="currentTotal === previousTotal">
                  <span class="description-percentage text-black">
                    0%
                  </span>
                </template>
                <template v-else>
                  <span class="description-percentage text-red">
                    <i class="fa fa-caret-down" />
                    <template v-if="previousTotal > 0">
                      {{ (-1) * ((currentTotal-previousTotal)/previousTotal) | percentage }}
                    </template>
                    <template v-else>
                      {{ (currentTotal) | percentage }}
                    </template>
                  </span>
                </template>
              </td>
            </tr>
            <tr>
              <td>{{ titleSecondary }}</td>
              <td>
                <p class="text-number">
                  $ {{ parseFloat(currentAmount) | separator }}
                </p>
              </td>
              <td>
                <p class="text-number">
                  $ {{ parseFloat(previousAmount) | separator }}
                </p>
              </td>
              <td>
                <template v-if="(currentAmount > previousAmount)">
                  <span class="description-percentage text-green">
                    <i class="fa fa-caret-up" />
                    <template v-if="previousAmount > 0">
                      {{ ((currentAmount-previousAmount)/previousAmount) | percentage }}
                    </template>
                    <template v-else>
                      {{ (currentAmount) | percentage }}
                    </template>
                  </span>
                </template>
                <template v-else-if="currentAmount === previousAmount">
                  <span class="description-percentage text-black">
                    0%
                  </span>
                </template>
                <template v-else>
                  <span class="description-percentage text-red">
                    <i class="fa fa-caret-down" />
                    <template v-if="previousAmount > 0">
                      {{ (-1) * (((currentAmount-previousAmount)/previousAmount)) | percentage }}
                    </template>
                    <template v-else>
                      {{ (currentAmount) | percentage }}
                    </template>
                  </span>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CashHeroTableWithChart',
  props: {
    titlePrimary: {
      type: String,
      required: true
    },
    titleSecondary: {
      type: String,
      required: true
    },
    currentTotal: {
      type: Number,
      required: true
    },
    previousTotal: {
      type: Number,
      required: true
    },
    currentAmount: {
      type: Number,
      required: true
    },
    previousAmount: {
      type: Number,
      required: true
    }
  },
  methods: {
    currencyFormat (price) {
      return price.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      })
    }
  }
}
</script>

<style scoped>
  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ddd;
    padding: 10px;
  }

  .text-number {
    font-size: 1em;
    font-weight: 800;
  }

  .line {
    border-bottom: 1px solid #bdbdbd;
  }

  .description-percentage {
    font-size: 1em;
  }
</style>
